import { createTheme } from '@material-ui/core/styles'

export const theme = createTheme({
  overrides: {
    MuiButton: {
      root: {
        padding: '8px 16px',
      },
      label: {
        //fontSize: 20,
        fontWeight: 600,
      }
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: '#000C',
        fontSize: '1rem',
      }
    },
  },
  typography: {
    fontFamily: '"Open Sans",Roboto,sans-serif',
  },
  palette: {
    primary: {
      light: '#6B33C7',
      main: '#4C1B9B',
      dark: '#3C1679',
      // contrastText: '#E8BDFD',
    },
    secondary: {
      light: '#98FFE8',
      main: '#45B59C',
      dark: '#50E2C1',
      darkx2: '#FF5C00',
      // contrastText: '#000',
    },
    error: {
      light: '#FFE6E6',
      main: '#FF0000',
      dark: '#C02020',
    },
    warning: {
      light: '#FFF8E6',
      main: '#FFC020',
      dark: '#FF9900',
    },
    info: {
      light: '#EBFAFF',
      main: '#40A0C0',
      dark: '#368099',
    },
    success: {
      light: '#ECF9EC',
      main: '#40C040',
      dark: '#2C872C',
    },    
    highlight: {
      yellow: '#FFD336',
    }, 
    grey: {
      50: '#FFFFFF',
      100: '#FFFFFF',
      200: '#F6F6F6',
      300: '#DDDDDD',
      400: '#C7C7C7',
      500: '#989898',
      600: '#707070',
      700: '#4B4B4B',
      800: '#333333',
      900: '#000000',
    },
  },
})